import { TiptapEditorHTMLView } from '@amzn/awscat-editor';

interface SimpleRichTextOutputProps {
  /** HTML or plain-text string to render. */
  value: string;
}

/**
 * Read-only renderer for content produced by SimpleRichTextInput.
 * Renders both HTML and plain-text strings via TiptapEditorHTMLView.
 */
const SimpleRichTextOutput = ({ value }: SimpleRichTextOutputProps) => {
  if (!value) return null;
  return <TiptapEditorHTMLView model={value} />;
};

export default SimpleRichTextOutput;
